import JobPuffs from './JobPuffs'

export default JobPuffs
